import { type ILoginResponse, type SchemaResponse, unAuth } from "@/modules/api/axios"

export type LoginWithEmailPayload = {
  email: string
  password: string
}

export const loginWithEmail = (payload: LoginWithEmailPayload) =>
  unAuth.post<SchemaResponse<ILoginResponse>>("auth/login", payload)
